import AssessmentIcon from "@mui/icons-material/Assessment";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TableChartIcon from "@mui/icons-material/TableChart";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import dayjs from "dayjs";
import { Component, memo } from "react";
import { connect } from "react-redux";
import "../../CSS/app.min.css";
import "../../CSS/bootstrap.min.css";
import "../../CSS/custom.min.css";
import "../../CSS/mermaid.min.css";
import "../../CSS/slickDashboard.css";

import { compose } from "@reduxjs/toolkit";
import ReactApexChart from "react-apexcharts";
import { Link, Link as RouterLink } from "react-router-dom";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import {
  getNewSalesTeamInfoByDateForAdmin,
  getSalesTeamInfoByDatesAndFlag,
  getSalesTeamInfoByDatesWithAttendance,
} from "../../Slice/adminDashboard.slice";
import { getBeatFromSalesTeamId } from "../../Slice/beat.slice";
import { getProductWithOrderAmt } from "../../Slice/companyCategoryConfiguration.slice";
import {
  getMonthTillDateWiseSales,
  getRegionNew,
  getTopPerformingProductsAndScheme,
  getUserCountsAndOrderAmt,
  getUsersCheckedInSummary,
  getActiveUsers,
  getActiveTeamMembers,
  getActiveDealers,
  getNewAddedOutlets,
  getOnclickDateWiseOrderAmtData,
  getOnclickProdWithOrderAmtData,
} from "../../Slice/region.slice";
import { withRouter } from "../../components/withRouter";
import { cyanBlue, primary } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import MonthlyBarChart from "../DashbourdChanges/MonthlyBarChart";
import { downloadF } from "../PDF/PDFDownload";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import SubscriptionExpiryMarquee from "../../components/dynamicscreens/SubscriptionExpiryBar";

class NewAnalyticalAdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "0",
      radioValue: [],
      activeCard: [],
      activeCardForUsers: 0,
      formErrors: {},
      dateForSalesTeamList: dayjs(),
      fromDate: dayjs(),
      toDate: dayjs(),
      totalOutletCount: 0,
      zero: 0,
      productiveCall: 0,
      unvisited: 0,
      totalOrderCall: 0,
      totalAmount: 0,
      salesAmt: 0,
      remoteOrder: 0,
      alignment: "0",
      prodWithOrderAmtAlignment: "0",
      searchValueForSalesTeamList: "",
      beatPopupFlag: false,
      salesTeamId: "",
      openIndex: null,
      openIndexForProd: null,
      activeTab: "0",
      tooltip: { visible: false, x: 0, y: 0, text: "" },
    };

    this.styles = {
      sectionForSalesTeam: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "100%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
    };

    this.accordionStyles = {
      accordionContainer: {
        width: "100%",
        overflowY: "auto",
        maxHeight: "475px",
        scrollBehavior: "smooth",
      },
      accordionItem: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        marginBottom: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
      },
      accordionHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 20px",
        backgroundColor: "#e0e5e7ff",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: 500,
        color: "#1e293b",
        transition: "background-color 0.3s ease",
      },
      accordionHeaderHover: {
        backgroundColor: "#f0f9ff",
      },
      accordionContent: {
        maxHeight: 0,
        overflow: "hidden",
        // padding: "0 20px",
        backgroundColor: "#fafafa",
        transition: "max-height 0.3s ease, padding 0.3s ease",
      },
      accordionContentOpen: {
        maxHeight: "400px", // Adjust based on content size
        overflowY: "scroll",
        // padding: "20px",
      },
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "400px", // Adjust as needed for your layout
        overflowY: "auto",
        width: "100%",
        display: "block", // Ensures proper scroll behavior
      },
      table: {
        width: "100%",
        borderCollapse: "collapse",
        display: "table", // Ensures table behaves correctly
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "#1C4E80", // Matches headerRow background
        zIndex: 10, // Ensures header stays above body
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "1000px",
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "#F9FBFC",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 16px",
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        fontWeight: 600,
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 16px",
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
      sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#374151",
      },
    };
  }

  async componentDidMount() {
    const {
      showLoador,
      showNotification,
      getUserCountsAndOrderAmt,
      getUsersCheckedInSummary,
      getProductWithOrderAmt,
      getRegionNew,
      getTopPerformingProductsAndScheme,
      getMonthTillDateWiseSales,
      getActiveUsers,
    } = this.props;

    if (navigator.onLine) {
      const userCountsSummaryData = localStorage.getItem("userCountsSummary");
      const userCountsSummaryLocalStorage = JSON.parse(userCountsSummaryData);

      const usersCheckedInSummaryData = localStorage.getItem(
        "usersCheckedInSummary"
      );
      const usersCheckedInSummaryLocalStorage = JSON.parse(
        usersCheckedInSummaryData
      );

      const productWithOrderAmtData = localStorage.getItem(
        "productWithOrderAmt"
      );

      const productWithOrderAmtLocalStorage = JSON.parse(
        productWithOrderAmtData
      );

      const topPerformingProductData = localStorage.getItem(
        "topPerformingProduct"
      );
      const topPerformingProductLocalStorage = JSON.parse(
        topPerformingProductData
      );

      const monthWiseSalesData = localStorage.getItem("monthWiseSales");
      const monthWiseSalesLocalStorage = JSON.parse(monthWiseSalesData);

      const activeUsersData = localStorage.getItem("activeUsersData");
      const activeUsersDataLocalStorage = JSON.parse(activeUsersData);

      const regionData = localStorage.getItem("regionData");
      const regionDataLocalStorage = JSON.parse(regionData);

      showLoador({ loador: true });

      let jsonData = [];

      if (!regionDataLocalStorage) {
        let regionIdsList = [];
        await getRegionNew().then(({ success, response }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            regionIdsList = response?.map((region) => region.id) || [];
            localStorage.setItem("regionData", JSON.stringify(response));
          }
        });
        jsonData = { regionIds: regionIdsList };
      } else {
        const regionIdsList = regionDataLocalStorage.map((region) => region.id);
        jsonData = { regionIds: regionIdsList };
      }

      if (!monthWiseSalesLocalStorage) {
        await getMonthTillDateWiseSales({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem("monthWiseSales", JSON.stringify(response));
            }
          }
        );
      }

      if (!userCountsSummaryLocalStorage) {
        await getUserCountsAndOrderAmt({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem(
                "userCountsSummary",
                JSON.stringify(response)
              );
            }
          }
        );
      }

      if (!usersCheckedInSummaryLocalStorage) {
        await getUsersCheckedInSummary({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem(
                "usersCheckedInSummary",
                JSON.stringify(response)
              );
            }
          }
        );
      }

      if (!productWithOrderAmtLocalStorage) {
        await getProductWithOrderAmt({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem(
                "productWithOrderAmt",
                JSON.stringify(response)
              );
            }
          }
        );
      }

      if (!activeUsersDataLocalStorage) {
        await getActiveUsers({ jsonData }).then(({ success, response }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("activeUsersData", JSON.stringify(response));
          }
        });
      }

      if (!topPerformingProductLocalStorage) {
        await getTopPerformingProductsAndScheme({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem(
                "topPerformingProduct",
                JSON.stringify(response)
              );
            }
          }
        );
      }
      const rowData = {
        date: dayjs().format("DD-MM-YYYY"),
      };
      this.onClickDateWiseOrderAmt(rowData, jsonData);

      this.onclickProdWithOrderAmtData(rowData, jsonData);

      showLoador({ loador: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const regionData = localStorage.getItem("regionData");
    const regionDataLocalStorage = JSON.parse(regionData);
    if (
      regionDataLocalStorage &&
      regionDataLocalStorage !== prevProps.regionDataLocalStorage
    ) {
      const allRegionIds = regionDataLocalStorage.map((r) => r.id);

      if (this.state.activeCard.length === 0) {
        this.setState({ activeCard: allRegionIds });
      }
    }

    if (prevState.activeCardForUsers !== this.state.activeCardForUsers) {
      if (prevState.activeCard.length !== 0) {
        this.fetchOnClickUsersData(this.state.activeCard);
      }
    }

    if (prevState.activeCard !== this.state.activeCard) {
      if (prevState.activeCard.length !== 0) {
        this.fetchSummaryDataByRegionIds(this.state.activeCard);
      }
    }
  }

  fetchSummaryDataByRegionIds = async (regionIds) => {
    const {
      showLoador,
      showNotification,
      getUserCountsAndOrderAmt,
      getUsersCheckedInSummary,
      getProductWithOrderAmt,
      getMonthTillDateWiseSales,
      getTopPerformingProductsAndScheme,
      getActiveUsers,
    } = this.props;

    if (navigator.onLine) {
      this.setState({ regionIds });

      const jsonData = { regionIds };

      let userResponse = null;
      let checkInResponse = null;

      showLoador({ loador: true });

      await getUserCountsAndOrderAmt({ jsonData }).then(
        ({ success, response }) => {
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            localStorage.setItem("userCountsSummary", JSON.stringify(response));
            userResponse = response;
          }
        }
      );

      await getUsersCheckedInSummary({ jsonData }).then(
        ({ success, response }) => {
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            localStorage.setItem(
              "usersCheckedInSummary",
              JSON.stringify(response)
            );
            checkInResponse = response;
          }
        }
      );

      await getProductWithOrderAmt({ jsonData }).then(
        ({ success, response }) => {
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            console.log(response);

            localStorage.setItem(
              "productWithOrderAmt",
              JSON.stringify(response)
            );
          }
        }
      );

      await getActiveUsers({ jsonData }).then(({ success, response }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          localStorage.setItem("activeUsersData", JSON.stringify(response));
        }
      });

      await getMonthTillDateWiseSales({ jsonData }).then(
        ({ success, response }) => {
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            localStorage.setItem("monthWiseSales", JSON.stringify(response));
          }
        }
      );

      await getTopPerformingProductsAndScheme({ jsonData }).then(
        ({ success, response }) => {
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            localStorage.setItem(
              "topPerformingProduct",
              JSON.stringify(response)
            );
          }
        }
      );

      const rowData = {
        date: dayjs().format("DD-MM-YYYY"),
      };
      this.onClickDateWiseOrderAmt(rowData);

      this.onclickProdWithOrderAmtData(rowData);

      this.setState({
        userCountsSummaryLocalStorage: userResponse,
        usersCheckedInSummaryLocalStorage: checkInResponse,
        activeCardForUsers: "0",
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
    showLoador({ loador: false });
  };

  fetchOnClickUsersData = async (regionIds) => {
    const {
      showLoador,
      showNotification,
      getActiveTeamMembers,
      getActiveUsers,
      getActiveDealers,
      getNewAddedOutlets,
    } = this.props;

    const { activeCardForUsers } = this.state;
    this.setState({ regionIds });

    const jsonData = { regionIds };

    if (navigator.onLine) {
      showLoador({ loador: true });
      if (activeCardForUsers == "0") {
        await getActiveUsers({ jsonData }).then(({ success, response }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("activeUsersData", JSON.stringify(response));
          }
        });
      } else if (activeCardForUsers == "1") {
        await getActiveTeamMembers({ jsonData }).then(
          ({ success, response }) => {
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              localStorage.setItem(
                "activeTeamMembersData",
                JSON.stringify(response)
              );
            }
          }
        );
      } else if (activeCardForUsers == "2") {
        await getActiveDealers({ jsonData }).then(({ success, response }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("activeDealersData", JSON.stringify(response));
          }
        });
      } else if (activeCardForUsers == "3") {
        await getNewAddedOutlets({ jsonData }).then(({ success, response }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("newAddedOutlet", JSON.stringify(response));
          }
        });
      }
      showLoador({ loador: false });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  changeDate = (name) => (e) => {
    const value = e.target.value;

    if (name === "fromDate") {
      this.setState({
        fromDate: dayjs(value),
      });
    }

    if (name === "toDate") {
      this.setState({
        toDate: dayjs(value),
      });
    }
  };

  searchSalesTeamData = () => {
    const {
      getSalesTeamInfoByDatesAndFlag,
      getNewSalesTeamInfoByDateForAdmin,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { fromDate, activeCard } = this.state;

    if (navigator.onLine) {
      let dataJson = {
        regionIds: activeCard,
        toDate: dayjs(fromDate).format("DD-MM-YYYY"),
        fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
      };
      showLoador({ loador: true });
      getNewSalesTeamInfoByDateForAdmin({
        // getSalesTeamInfoByDatesAndFlag({
        dataJson,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: response.errorMessage ?? serverMsg,
            severity: "error",
          });
        } else {
          let totalOutletCount = 0,
            zero = 0,
            productiveCall = 0,
            unvisited = 0,
            salesAmt = 0,
            totalAmount = 0,
            remoteOrder = 0;
          if (response.length !== 0) {
            response.map((salesTeam) => {
              totalOutletCount = totalOutletCount + +salesTeam.totalOutletCount;
              productiveCall = productiveCall + +salesTeam.productiveCall;
              zero = zero + +salesTeam.zeroOrderCount;
              unvisited = unvisited + +salesTeam.unvisitedOutletCount;
              salesAmt = salesAmt + +salesTeam.totalSalesAmt;
              totalAmount = totalAmount + +salesTeam.totalAmount;
              remoteOrder = remoteOrder + +salesTeam.remoteOrderCount;
            });
          }
          this.setState({
            totalOutletCount: totalOutletCount,
            zero: zero,
            productiveCall: productiveCall,
            unvisited: unvisited,
            salesAmt: salesAmt,
            totalAmount: totalAmount,
            remoteOrder: remoteOrder,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  getFilteredTableDataForSalesTeamList = (searchData) => {
    const { searchValueForSalesTeamList } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["district_names"] &&
          currentRow["district_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["area_names"] &&
          currentRow["area_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSearchForSalesTeamList = (e) => {
    this.setState({
      searchValueForSalesTeamList: e.target.value,
    });
  };

  handleChangeTabValue = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  salesTeamHandler = (e, salesTeamId) => {
    const { getBeatFromSalesTeamId, showLoador, showNotification } = this.props;
    const { popUpFlag } = this.state;

    this.setState({
      salesTeamId: salesTeamId,
    });
    if (navigator.onLine) {
      showLoador({ loador: true });
      getBeatFromSalesTeamId({
        salesTeamIds: salesTeamId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            beatPopupFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, activeCard } = this.state;

    const dataToSave = {
      fromDate: dayjs(fromDate).format("DD-MM-YYYY"),
      toDate: dayjs(fromDate).format("DD-MM-YYYY"),
      regionIds: activeCard,
      flag: 7,
    };
    // http://localhost:8088/api/distributiondevelop/v1/export/sales-teams-with-count-and-check-in-status-by-dates-and-region-excel
    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url:
          endpoint.exportData +
          "/sales-teams-with-count-and-check-in-status-by-dates-and-region-excel",
        ext: "xlsx",
        openNewTab: true,
        postBody: dataToSave,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  handleClosesSalesTeam = () => {
    this.setState({
      beatPopupFlag: false,
    });
  };

  setActiveCardForUsers = (e, setFlag) => {
    this.setState({
      activeCardForUsers: setFlag,
    });
  };

  handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      this.setState({ alignment: newAlignment });
    }
  };

  dateWiseOrderAmtHandleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      this.setState({ prodWithOrderAmtAlignment: newAlignment });
    }
  };

  handleToggle(index) {
    this.setState({
      openIndex: this.state.openIndex === index ? null : index,
    });
  }

  handleToggleForProd(index) {
    this.setState({
      openIndexForProd: this.state.openIndexForProd === index ? null : index,
    });
  }

  showTooltip = (event, text) => {
    const rect = event.target.getBoundingClientRect();
    this.setState({
      tooltip: {
        visible: true,
        x: rect.left + window.scrollX + rect.width,
        y: rect.top + window.scrollY + 10,
        text,
      },
    });
  };

  hideTooltip = () => {
    this.setState({ tooltip: { visible: false, x: 0, y: 0, text: "" } });
  };

  hideTooltipWithDelay = () => {
    this.tooltipTimeout = setTimeout(() => {
      this.hideTooltip();
    }, 100); // 200ms delay
  };

  onClickDateWiseOrderAmt = async (rowData, jsonDataProp) => {
    const { getOnclickDateWiseOrderAmtData, showNotification, showLoador } =
      this.props;
    const { activeCard } = this.state;
    console.debug(activeCard);
    const jsonData = {
      regionIds: activeCard.length != 0 ? activeCard : jsonDataProp.regionIds,
      fromDate: rowData.date,
      toDate: rowData.date,
    };
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getOnclickDateWiseOrderAmtData({
        jsonData,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onclickProdWithOrderAmtData = async (rowData, jsonDataProp) => {
    const { getOnclickProdWithOrderAmtData, showNotification, showLoador } =
      this.props;
    const { activeCard } = this.state;
    console.debug(activeCard);
    const jsonData = {
      regionIds: activeCard.length != 0 ? activeCard : jsonDataProp.regionIds,
      fromDate: rowData.date,
      toDate: rowData.date,
    };
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getOnclickProdWithOrderAmtData({
        jsonData,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  changeRegion = (region) => {
    const { activeCard } = this.state;
    const isSelected = activeCard.includes(region.id);
    const updatedSelection = isSelected
      ? activeCard.filter((id) => id !== region.id)
      : [...activeCard, region.id];
    this.setState({ activeCard: updatedSelection });
  };

  renderAccordionItem = (item, index) => {
    const { primary } = this.props;
    const { openIndex, hoveredIndex } = this.state;
    const isOpen = openIndex === index;
    const isHovered = hoveredIndex === index;

    return (
      <div style={this.accordionStyles.accordionItem} key={index}>
        <div
          style={{
            ...this.accordionStyles.accordionHeader,
            ...(isHovered ? this.accordionStyles.accordionHeaderHover : {}),
          }}
          onClick={() => this.handleToggle(index)}
        // onMouseEnter={() => this.setState({ hoveredIndex: index })}
        // onMouseLeave={() => this.setState({ hoveredIndex: null })}
        >
          <span>
            {item.name}
            {item.prefix ? "(" + item.prefix + ")" : ""} -{" "}
            <span style={{ color: primary }}>
              ₹{Number(item.orderAmt).toFixed(2)}
            </span>
          </span>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>
        <div
          style={{
            ...this.accordionStyles.accordionContent,
            ...(isOpen ? this.accordionStyles.accordionContentOpen : {}),
          }}
        >
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table style={this.tableStyles.table}>
              <thead style={this.tableStyles.stickyHeader}>
                <tr style={this.tableStyles.headerRow}>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "center",
                    }}
                  >
                    Sr. no
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "left",
                    }}
                  >
                    Sales Team Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "left",
                    }}
                  >
                    Type
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Order Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {item?.underSalesTeamList?.map((subItem, subIndex) => (
                  <tr
                    key={subItem.id || subIndex}
                    style={{
                      ...this.tableStyles.dataRow,
                      ...(subIndex % 2 === 0
                        ? this.tableStyles.alternateRow
                        : {}),
                    }}
                    onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      this.tableStyles.dataRowHover.backgroundColor)
                    }
                    onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      subIndex % 2 === 0
                        ? this.tableStyles.alternateRow.backgroundColor
                        : this.tableStyles.dataRow.backgroundColor)
                    }
                  >
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "center",
                      }}
                    >
                      {subIndex + 1}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "left",
                      }}
                    >
                      {subItem.name}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "left",
                      }}
                    >
                      {subItem.stockStakeTypeName}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹{Number(subItem.orderAmt).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  renderProductAccordionItem = (item, index) => {
    const { primary } = this.props;
    const { openIndexForProd, hoveredIndex } = this.state;
    const isOpen = openIndexForProd === index;
    const isHovered = hoveredIndex === index;
    return (
      <div style={this.accordionStyles.accordionItem} key={index}>
        <div
          style={{
            ...this.accordionStyles.accordionHeader,
            ...(isHovered ? this.accordionStyles.accordionHeaderHover : {}),
          }}
          onClick={() => this.handleToggleForProd(index)}
        // onMouseEnter={() => this.setState({ hoveredIndex: index })}
        // onMouseLeave={() => this.setState({ hoveredIndex: null })}
        >
          <span>
            {item.name} -{" "}
            <span style={{ color: primary }}>
              ₹{Number(item.orderAmt).toFixed(2)}
            </span>
          </span>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>
        <div
          style={{
            ...this.accordionStyles.accordionContent,
            ...(isOpen ? this.accordionStyles.accordionContentOpen : {}),
          }}
        >
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table style={this.tableStyles.table}>
              <thead style={this.tableStyles.stickyHeader}>
                <tr style={this.tableStyles.headerRow}>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "center",
                    }}
                  >
                    Sr. no
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "left",
                    }}
                  >
                    Product Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Order Amount
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Order Qty
                  </th>
                </tr>
              </thead>
              <tbody>
                {item?.product?.map((subItem, subIndex) => (
                  <tr
                    key={subItem.id || subIndex}
                    style={{
                      ...this.tableStyles.dataRow,
                      ...(subIndex % 2 === 0
                        ? this.tableStyles.alternateRow
                        : {}),
                    }}
                    onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      this.tableStyles.dataRowHover.backgroundColor)
                    }
                    onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      subIndex % 2 === 0
                        ? this.tableStyles.alternateRow.backgroundColor
                        : this.tableStyles.dataRow.backgroundColor)
                    }
                  >
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "center",
                      }}
                    >
                      {subIndex + 1}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "left",
                      }}
                    >
                      {subItem?.name || "-"}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹{Number(subItem?.orderAmt).toFixed(2)}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      {subItem?.orderQty || 0}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { userCountsList, dashboardData } = this.props;
    const {
      totalOutletCount,
      productiveCall,
      unvisited,
      zero,
      totalAmount,
      salesAmt,
      alignment,
      activeTab,
      prodWithOrderAmtAlignment,
    } = this.state;

    const regionData = localStorage.getItem("regionData");
    const regionDataLocalStorage = JSON.parse(regionData);

    const userCountsSummaryData = localStorage.getItem("userCountsSummary");
    const userCountsSummaryLocalStorage = JSON.parse(userCountsSummaryData);

    const usersCheckedInSummaryData = localStorage.getItem(
      "usersCheckedInSummary"
    );
    const usersCheckedInSummaryLocalStorage = JSON.parse(
      usersCheckedInSummaryData
    );

    const productWithOrderAmtData = localStorage.getItem("productWithOrderAmt");
    const productWithOrderAmtLocalStorage = JSON.parse(productWithOrderAmtData);

    const activeUsersData = localStorage.getItem("activeUsersData");
    const activeUsersDataLocalStorage = JSON.parse(activeUsersData);

    const monthWiseSalesData = localStorage.getItem("monthWiseSales");
    const monthWiseSalesLocalStorage = JSON.parse(monthWiseSalesData);

    const activeTeamMembersData = localStorage.getItem("activeTeamMembersData");
    const activeTeamMembersDataLocalStorage = JSON.parse(activeTeamMembersData);

    const activeDealersData = localStorage.getItem("activeDealersData");
    const activeDealersDataLocalStorage = JSON.parse(activeDealersData);

    const newAddedOutlet = localStorage.getItem("newAddedOutlet");
    const newAddedOutletDataLocalStorage = JSON.parse(newAddedOutlet);

    const topPerformingProductData = localStorage.getItem(
      "topPerformingProduct"
    );
    const topPerformingProductLocalStorage = JSON.parse(
      topPerformingProductData
    );

    const showPaymentValidationMsg =
      localStorage.getItem("showPaymentValidationMsg");

    const paymentMessage =
      localStorage.getItem("paymentValidationMsg") ?? "";

    const shouldShow =
      showPaymentValidationMsg !== null &&
      showPaymentValidationMsg != 0;

    return (
      <>
        {shouldShow && (
          <SubscriptionExpiryMarquee
            message={paymentMessage}
            position="form"
          />
        )}
        <div
          id="layout-wrapper"
          style={{
            backgroundColor: "#F8FAFC",
          }}
        >
          {/* ========== App Menu ========== */}

          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here
            {/* ============================================================== */}
          <div className="main-content">
            <div
              className="page-content"
              style={{
                padding: "5px 20px 5px 20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%", // Ensure the parent container takes full width
                }}
              >
                <h1
                  style={{
                    fontSize: "28px",
                    fontWeight: 700,
                    color: "#1e293b",
                    letterSpacing: "0.8px",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  Dashboard
                  <span
                    style={{
                      content: "''",
                      position: "absolute",
                      left: 0,
                      bottom: 0,
                      height: "4px",
                      width: "30%",
                      background: "linear-gradient(90deg, #00b1ff, #62cff4)",
                      borderRadius: "2px",
                    }}
                  ></span>
                </h1>

                {/* Region Div Start */}
                <div
                  style={{
                    display: "flex",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#888 #f1f1f1",
                    width: "60%",
                    maxWidth: "60%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      gap: "11px",
                      overflowX: "auto",
                      // width: "60%",
                      // maxWidth: "60%",
                      // justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {regionDataLocalStorage?.map((region) => (
                      <div
                        key={region.id}
                        onClick={() => this.changeRegion(region)}
                        style={{
                          background: "white",
                          borderRadius: 50,
                          border: this.state.activeCard.includes(region.id)
                            ? "2px solid #3dc3f8"
                            : "1px solid #E6E6E6",
                          boxShadow: this.state.activeCard.includes(region.id)
                            ? "0 0 5px rgba(61, 195, 248, 0.6)"
                            : "none",
                          padding: "10px 12px",
                          cursor: "pointer",
                          textAlign: "center",
                          transition:
                            "transform 0.2s ease, box-shadow 0.2s ease",
                          height: "40px",
                          minWidth: "100px", // Ensure each item has a minimum width
                          width: "auto",
                          flexShrink: 0, // Prevent items from shrinking
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: this.state.activeCard.includes(region.id)
                              ? "#3dc3f8"
                              : "#000000",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={region.name}
                        >
                          {region.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* New Card from chaitanya start */}

              <div
                className="row"
                style={{
                  gap: 10,
                  marginBottom: 2,
                  flexDirection: "row",
                  width: "101.7%",
                  padding: "5px 10px 0px 10px",
                }}
              >
                {/* User Summary Work Chart Start */}
                <div
                  style={{
                    width: "59%",
                    background: "white",
                    borderRadius: 8,
                    // border: "1px #E6E6E6 solid",
                    justifyContent: "space-between",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  {/* Sales & Manpower Table 2 starts */}
                  <div
                    style={{
                      marginBottom: -2,
                      background: "white",
                      borderRadius: 8,
                      border: "0 #E6E6E6 solid",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "65%",
                      }}
                    >
                      <div
                        onClick={(e) => this.setActiveCardForUsers(e, 0)}
                        style={{
                          background: "white",
                          // borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          padding: "10px 15px",
                          borderTop:
                            this.state.activeCardForUsers == "0"
                              ? "3px solid #3dc3f8"
                              : "1px solid #fff",
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 400,
                              color:
                                this.state.activeCardForUsers == "0" &&
                                "#3dc3f8",
                            }}
                          >
                            Active users
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 26,
                            marginTop: 2,
                            color:
                              this.state.activeCardForUsers == "0" && "#3dc3f8",
                          }}
                        >
                          {userCountsSummaryLocalStorage !== null &&
                            userCountsSummaryLocalStorage?.length !== 0 &&
                            userCountsSummaryLocalStorage !== undefined &&
                            userCountsSummaryLocalStorage.activeOutletCount &&
                            userCountsSummaryLocalStorage.activeOutletCount !==
                            null
                            ? userCountsSummaryLocalStorage.activeOutletCount
                            : 0}
                        </div>
                      </div>

                      <div
                        onClick={(e) => this.setActiveCardForUsers(e, 1)}
                        style={{
                          background: "white",
                          // borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          padding: "10px 15px",
                          borderTop:
                            this.state.activeCardForUsers == "1"
                              ? "3px solid #3dc3f8"
                              : "1px solid #fff",
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 400,
                              color:
                                this.state.activeCardForUsers == "1" &&
                                "#3dc3f8",
                            }}
                          >
                            Active team members
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 26,
                            marginTop: 2,
                            color:
                              this.state.activeCardForUsers == "1" && "#3dc3f8",
                          }}
                        >
                          {userCountsSummaryLocalStorage !== null &&
                            userCountsSummaryLocalStorage?.length !== 0 &&
                            userCountsSummaryLocalStorage !== undefined &&
                            userCountsSummaryLocalStorage.activeSalesTeamCount !==
                            null
                            ? userCountsSummaryLocalStorage.activeSalesTeamCount
                            : 0}
                        </div>
                      </div>

                      <div
                        onClick={(e) => this.setActiveCardForUsers(e, 2)}
                        style={{
                          background: "white",

                          border: "0 #E6E6E6 solid",
                          padding: "10px 15px",
                          borderTop:
                            this.state.activeCardForUsers == "2"
                              ? "3px solid #3dc3f8"
                              : "1px solid #fff",
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 400,
                              color:
                                this.state.activeCardForUsers == "2" &&
                                "#3dc3f8",
                            }}
                          >
                            Active dealers
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 26,
                            marginTop: 2,
                            color:
                              this.state.activeCardForUsers == "2" && "#3dc3f8",
                          }}
                        >
                          {userCountsSummaryLocalStorage !== null &&
                            userCountsSummaryLocalStorage?.length !== 0 &&
                            userCountsSummaryLocalStorage !== undefined &&
                            userCountsSummaryLocalStorage.activeStockStakeHolderCount !==
                            null
                            ? userCountsSummaryLocalStorage.activeStockStakeHolderCount
                            : 0}
                        </div>
                      </div>

                      <div
                        onClick={(e) => this.setActiveCardForUsers(e, 3)}
                        style={{
                          background: "white",

                          border: "0 #E6E6E6 solid",
                          padding: "10px 15px",
                          borderTop:
                            this.state.activeCardForUsers == "3"
                              ? "3px solid #3dc3f8"
                              : "1px solid #fff",
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 400,
                              color:
                                this.state.activeCardForUsers == "3" &&
                                "#3dc3f8",
                            }}
                          >
                            New outlets
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 26,
                            marginTop: 2,
                            color:
                              this.state.activeCardForUsers == "3" && "#3dc3f8",
                          }}
                        >
                          {userCountsSummaryLocalStorage !== null &&
                            userCountsSummaryLocalStorage?.length !== 0 &&
                            userCountsSummaryLocalStorage !== undefined &&
                            userCountsSummaryLocalStorage.newlyAddedOutletCount !==
                            null
                            ? userCountsSummaryLocalStorage.newlyAddedOutletCount
                            : 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.activeCardForUsers == "0" ? (
                    activeUsersDataLocalStorage &&
                      activeUsersDataLocalStorage?.length !== 0 ? (
                      <>
                        <MonthlyBarChart
                          // radioValue={onChangeRadioValue}
                          height={300}
                          type={"line"}
                          series={[
                            {
                              data:
                                activeUsersDataLocalStorage &&
                                activeUsersDataLocalStorage?.length !== 0 &&
                                activeUsersDataLocalStorage.map((dataObj) =>
                                  dataObj.value !== null ? dataObj.value : 0
                                ),
                            },
                          ]}
                          optionsObj={{
                            chart: {
                              type: "line",
                              height: 365,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => { },
                              },
                            },

                            plotOptions: {
                              bar: {
                                columnWidth: "30%",
                                distributed: true,
                              },
                            },
                            stroke: {
                              show: true,
                              width: 2,
                              // colors: ["transparent"],
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              categories:
                                activeUsersDataLocalStorage?.length !== 0 &&
                                activeUsersDataLocalStorage?.map((dataObj) =>
                                  dataObj.name !== null ? dataObj.name : 0
                                ),
                            },
                            // yaxis: {
                            // title: {
                            // text: "$ (thousands)",
                            // },
                            // },
                            fill: {
                              opacity: 1,
                            },
                            colors: [
                              "#FD9600",
                              "#00FFFF",
                              "#008000",
                              "#DE00FD",
                              "#FF0000",
                              "#000FFF",
                              "#61EE9B",
                            ],

                            tooltip: {
                              theme: "light",
                            },
                          }}
                        />
                      </>
                    ) : null
                  ) : this.state.activeCardForUsers == "1" ? (
                    activeTeamMembersDataLocalStorage &&
                      activeTeamMembersDataLocalStorage?.length !== 0 ? (
                      <>
                        <MonthlyBarChart
                          // radioValue={onChangeRadioValue}
                          height={300}
                          type={"line"}
                          series={[
                            {
                              data:
                                activeTeamMembersDataLocalStorage &&
                                activeTeamMembersDataLocalStorage?.length !==
                                0 &&
                                activeTeamMembersDataLocalStorage.map(
                                  (dataObj) =>
                                    dataObj.value !== null ? dataObj.value : 0
                                ),
                            },
                          ]}
                          optionsObj={{
                            chart: {
                              type: "line",
                              height: 365,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => { },
                              },
                            },

                            plotOptions: {
                              bar: {
                                columnWidth: "30%",
                                distributed: true,
                              },
                            },
                            stroke: {
                              show: true,
                              width: 2,
                              // colors: ["transparent"],
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              categories:
                                activeTeamMembersDataLocalStorage?.length !==
                                0 &&
                                activeTeamMembersDataLocalStorage?.map(
                                  (dataObj) =>
                                    dataObj.name !== null ? dataObj.name : 0
                                ),
                            },
                            // yaxis: {
                            // title: {
                            // text: "$ (thousands)",
                            // },
                            // },
                            fill: {
                              opacity: 1,
                            },
                            colors: [
                              "#FD9600",
                              "#00FFFF",
                              "#008000",
                              "#DE00FD",
                              "#FF0000",
                              "#000FFF",
                              "#61EE9B",
                            ],

                            tooltip: {
                              theme: "light",
                            },
                          }}
                        />
                      </>
                    ) : null
                  ) : this.state.activeCardForUsers == "2" ? (
                    activeDealersDataLocalStorage &&
                      activeDealersDataLocalStorage?.length !== 0 ? (
                      <>
                        <MonthlyBarChart
                          // radioValue={onChangeRadioValue}
                          height={300}
                          type={"line"}
                          series={[
                            {
                              data:
                                activeDealersDataLocalStorage &&
                                activeDealersDataLocalStorage?.length !== 0 &&
                                activeDealersDataLocalStorage.map((dataObj) =>
                                  dataObj.value !== null ? dataObj.value : 0
                                ),
                            },
                          ]}
                          optionsObj={{
                            chart: {
                              type: "line",
                              height: 365,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => { },
                              },
                            },

                            plotOptions: {
                              bar: {
                                columnWidth: "30%",
                                distributed: true,
                              },
                            },
                            stroke: {
                              show: true,
                              width: 2,
                              // colors: ["transparent"],
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              categories:
                                activeDealersDataLocalStorage?.length !== 0 &&
                                activeDealersDataLocalStorage?.map((dataObj) =>
                                  dataObj.name !== null ? dataObj.name : 0
                                ),
                            },
                            // yaxis: {
                            // title: {
                            // text: "$ (thousands)",
                            // },
                            // },
                            fill: {
                              opacity: 1,
                            },
                            colors: [
                              "#FD9600",
                              "#00FFFF",
                              "#008000",
                              "#DE00FD",
                              "#FF0000",
                              "#000FFF",
                              "#61EE9B",
                            ],

                            tooltip: {
                              theme: "light",
                            },
                          }}
                        />
                      </>
                    ) : null
                  ) : this.state.activeCardForUsers == "3" ? (
                    newAddedOutletDataLocalStorage &&
                      newAddedOutletDataLocalStorage?.length !== 0 ? (
                      <>
                        <MonthlyBarChart
                          // radioValue={onChangeRadioValue}
                          height={300}
                          type={"line"}
                          series={[
                            {
                              data:
                                newAddedOutletDataLocalStorage &&
                                newAddedOutletDataLocalStorage?.length !== 0 &&
                                newAddedOutletDataLocalStorage.map((dataObj) =>
                                  dataObj.value !== null ? dataObj.value : 0
                                ),
                            },
                          ]}
                          optionsObj={{
                            chart: {
                              type: "line",
                              height: 365,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => { },
                              },
                            },

                            plotOptions: {
                              bar: {
                                columnWidth: "30%",
                                distributed: true,
                              },
                            },
                            stroke: {
                              show: true,
                              width: 2,
                              // colors: ["transparent"],
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              categories:
                                newAddedOutletDataLocalStorage?.length !== 0 &&
                                newAddedOutletDataLocalStorage?.map((dataObj) =>
                                  dataObj.name !== null ? dataObj.name : 0
                                ),
                            },
                            // yaxis: {
                            // title: {
                            // text: "$ (thousands)",
                            // },
                            // },
                            fill: {
                              opacity: 1,
                            },
                            colors: [
                              "#FD9600",
                              "#00FFFF",
                              "#008000",
                              "#DE00FD",
                              "#FF0000",
                              "#000FFF",
                              "#61EE9B",
                            ],

                            tooltip: {
                              theme: "light",
                            },
                          }}
                        />
                      </>
                    ) : null
                  ) : null}
                </div>

                {/* User Summary Work Chart end */}

                {/* Time Slot Wise start */}

                <div
                  style={{
                    width: "40%",
                    background: "white",
                    padding: 10,
                    borderRadius: 8,
                    // border: "1px #E6E6E6 solid",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    display: "flex",
                    // gap: 10,
                    maxHeight: "400px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={
                      {
                        // marginBottom: -2,
                        // background: "white",
                        // borderRadius: 8,
                        // border: "0 #E6E6E6 solid",
                      }
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          padding: "5px 0 10px 0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 400,
                            }}
                          >
                            Number of Users Checked In Today
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 26,
                            marginTop: 2,
                            color: "#004969",
                            textAlign: "left",
                          }}
                        >
                          {/* {filteredStakeholders?.reduce(
                            (sum, item) => sum + (item.checkInCount || 0),
                            0
                          )} */}
                          {usersCheckedInSummaryLocalStorage &&
                            usersCheckedInSummaryLocalStorage.todaysTotalCheckedInCount !==
                            null
                            ? usersCheckedInSummaryLocalStorage.todaysTotalCheckedInCount
                            : 0}
                        </div>
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}
                        >
                          Users Per Hour
                          <div
                            style={{
                              fontSize: 26,
                              marginTop: 2,
                              color: "#004969",
                            }}
                          >
                            {/* {filteredStakeholders?.reduce(
                            (sum, item) => sum + (item.checkInCount || 0),
                            0
                          )} */}
                            {usersCheckedInSummaryLocalStorage &&
                              usersCheckedInSummaryLocalStorage.lastHourCheckedInCount !==
                              null
                              ? usersCheckedInSummaryLocalStorage.lastHourCheckedInCount
                              : 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      overflow: "auto",
                    }}
                  >
                    {usersCheckedInSummaryLocalStorage?.stockStakeHolderTypesWithCheckInCount?.map(
                      (item, index) => {
                        const percent = item.checkInCount || 0;
                        const totalSalesTeamCount = item.salesTeamCount || 0;
                        const name = item.name || "N/A";

                        return (
                          <div key={index}>
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 500,
                                marginBottom: 4,
                                color: "#004969",
                              }}
                            >
                              {name} — {percent}/{totalSalesTeamCount}
                            </div>
                            <div
                              style={{
                                height: "8px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "6px",
                                overflow: "hidden",
                                width: "95%",
                              }}
                            >
                              <div
                                style={{
                                  width:
                                    (percent / totalSalesTeamCount) * 100 + "%",
                                  height: "100%",
                                  backgroundColor: "#3dc3f8",
                                  transition: "width 0.3s ease",
                                }}
                              ></div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
                {/* Time Slot Wise end */}

                {/* Time Slot Wise end */}
              </div>

              {/* New Card from chaitanya end */}
              <div
                // className="container-fluid"
                style={{
                  paddingLeft: 0,
                }}
              >
                {/* Cards 1 :  User Stats & Order Overview cards */}

                <div
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    // overflowX: "auto",
                    gap: "8px",
                    marginTop: "15px",
                  }}
                >
                  {/* Bar Graph 1 : Date Wise Order AMT
                   */}
                  <div
                    style={{
                      width: "50%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: 10,
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2
                        style={{
                          fontSize: "15px",
                          fontWeight: "400",
                          color: "#1e293b",
                          padding: "2px 5px",
                          border: "1px solid #00b1ff",
                          borderRadius: "5px",
                          display: "inline-block",
                          letterSpacing: "0.6px",
                          backgroundColor: "#ffff",
                        }}
                      >
                        Date Wise Order AMT
                      </h2>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          flexDirection: "row",
                          width: "50%",
                        }}
                      >
                        <ToggleButtonGroup
                          color="primary"
                          value={alignment}
                          exclusive
                          onChange={this.handleChange}
                          size="small"
                          aria-label="Small sizes"
                          sx={{
                            "& .MuiToggleButton-root": {
                              height: "35px",
                              fontSize: "0.75rem",
                            },
                          }}
                        >
                          <ToggleButton value="0">
                            <AssessmentIcon />
                          </ToggleButton>
                          <ToggleButton value="1">
                            <TableChartIcon />
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </div>
                    {alignment == "0" ? (
                      <ReactApexChart
                        options={{
                          chart: {
                            type: "bar",
                            height: 300,
                            events: {
                              dataPointSelection: (
                                event,
                                chartContext,
                                config
                              ) => {
                                const dataId =
                                  userCountsSummaryLocalStorage
                                    ?.dateWiseOrderAmt[config.dataPointIndex];
                                this.onClickDateWiseOrderAmt(dataId);
                              },
                            },
                          },
                          dataLabels: { enabled: false },
                          stroke: { curve: "smooth" },
                          xaxis: {
                            categories:
                              userCountsSummaryLocalStorage?.dateWiseOrderAmt
                                ?.length > 0
                                ? userCountsSummaryLocalStorage?.dateWiseOrderAmt.map(
                                  (item) => item.date.split("T")[0]
                                )
                                : [],
                          },
                          tooltip: { theme: "light" },
                        }}
                        series={[
                          {
                            name: "Amount",
                            data:
                              userCountsSummaryLocalStorage?.dateWiseOrderAmt
                                ?.length > 0
                                ? userCountsSummaryLocalStorage?.dateWiseOrderAmt.map(
                                  (item) => item.amt
                                )
                                : [],
                          },
                        ]}
                        type="bar"
                        height={400}
                        width="100%"
                      />
                    ) : (
                      <div
                        style={{
                          // paddingTop: "1px",
                          maxHeight: "500px",
                          overflowY: "auto",
                        }}
                      >
                        <table style={this.tableStyles.table}>
                          <thead style={this.tableStyles.stickyHeader}>
                            <tr style={this.tableStyles.headerRow}>
                              <th
                                style={{
                                  ...this.tableStyles.headerCell,
                                  textAlign: "center",
                                }}
                              >
                                Sr. no
                              </th>
                              <th
                                style={{
                                  ...this.tableStyles.headerCell,
                                  textAlign: "center",
                                }}
                              >
                                Date
                              </th>
                              <th
                                style={{
                                  ...this.tableStyles.headerCell,
                                  textAlign: "right",
                                }}
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {userCountsSummaryLocalStorage?.dateWiseOrderAmt?.map(
                              (item, index, array) => (
                                <tr
                                  key={item.id || index}
                                  style={{
                                    ...this.tableStyles.dataRow,
                                    ...(index % 2 === 0
                                      ? this.tableStyles.alternateRow
                                      : {}),
                                  }}
                                  onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    this.tableStyles.dataRowHover.backgroundColor)
                                  }
                                  onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    index % 2 === 0
                                      ? this.tableStyles.alternateRow
                                        .backgroundColor
                                      : this.tableStyles.dataRow
                                        .backgroundColor)
                                  }
                                >
                                  <td
                                    style={{
                                      ...this.tableStyles.dataCell,
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.index}
                                  </td>
                                  <td
                                    style={{
                                      ...this.tableStyles.dataCell,
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.date}
                                  </td>
                                  <td
                                    style={{
                                      ...this.tableStyles.dataCell,
                                      ...this.tableStyles.amountCell,
                                      textAlign: "right",
                                    }}
                                  >
                                    ₹{+item.amt.toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  {/* <div></div> */}

                  {/* Bar Graph  2 : Product With Order AMT
                   */}
                  <div
                    style={{
                      width: "50%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: "15px",
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {userCountsList.onclickDateWiseOrderAmtData.length <= 0 ? (
                      <NoDataFound />
                    ) : (
                      <>
                        <div style={this.accordionStyles.accordionContainer}>
                          {userCountsList.onclickDateWiseOrderAmtData.map(
                            this.renderAccordionItem
                          )}
                        </div>
                        {/* <div style={this.accordionStyles.accordionContainer}>
                          {userCountsList != null &&
                            userCountsList &&
                            userCountsList.onclickDateWiseOrderAmtData.map(
                              (item, index) => (
                                <div
                                  style={this.accordionStyles.accordionItem}
                                  key={index}
                                >
                                  <div
                                    style={{
                                      ...this.accordionStyles.accordionHeader,
                                      ...(this.state.hoveredIndex === index
                                        ? this.accordionStyles
                                            .accordionHeaderHover
                                        : {}),
                                    }}
                                    onClick={() => this.handleToggle(index)}
                                    onMouseEnter={() =>
                                      this.setState({ hoveredIndex: index })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({ hoveredIndex: null })
                                    }
                                  >
                                    <span>
                                      {item.name}({item.prefix}) -{" "}
                                      <span
                                        style={{
                                          color: primary,
                                        }}
                                      >
                                        ₹{+item.orderAmt.toFixed(2)}
                                      </span>
                                    </span>
                                    {this.state.openIndex === index ? (
                                      <ExpandLessIcon />
                                    ) : (
                                      <ExpandMoreIcon />
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      ...this.accordionStyles.accordionContent,
                                      ...(this.state.openIndex === index
                                        ? this.accordionStyles
                                            .accordionContentOpen
                                        : {}),
                                    }}
                                  >
                                    <div
                                      style={{
                                        // paddingTop: "1px",
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      <table style={this.tableStyles.table}>
                                        <thead
                                          style={this.tableStyles.stickyHeader}
                                        >
                                          <tr
                                            style={this.tableStyles.headerRow}
                                          >
                                            <th
                                              style={{
                                                ...this.tableStyles.headerCell,
                                                textAlign: "center",
                                              }}
                                            >
                                              Sr. no
                                            </th>
                                            <th
                                              style={{
                                                ...this.tableStyles.headerCell,
                                                textAlign: "left",
                                              }}
                                            >
                                              Sales Team Name
                                            </th>
                                            <th
                                              style={{
                                                ...this.tableStyles.headerCell,
                                                textAlign: "left",
                                              }}
                                            >
                                              Type
                                            </th>
                                            <th
                                              style={{
                                                ...this.tableStyles.headerCell,
                                                textAlign: "right",
                                              }}
                                            >
                                              Order Amount
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.underSalesTeamList?.map(
                                            (item, index, array) => (
                                              <tr
                                                key={item.id || index}
                                                style={{
                                                  ...this.tableStyles.dataRow,
                                                  ...(index % 2 === 0
                                                    ? this.tableStyles
                                                        .alternateRow
                                                    : {}),
                                                }}
                                                onMouseEnter={(e) =>
                                                  (e.currentTarget.style.backgroundColor =
                                                    this.tableStyles.dataRowHover.backgroundColor)
                                                }
                                                onMouseLeave={(e) =>
                                                  (e.currentTarget.style.backgroundColor =
                                                    index % 2 === 0
                                                      ? this.tableStyles
                                                          .alternateRow
                                                          .backgroundColor
                                                      : this.tableStyles.dataRow
                                                          .backgroundColor)
                                                }
                                              >
                                                <td
                                                  style={{
                                                    ...this.tableStyles
                                                      .dataCell,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  style={{
                                                    ...this.tableStyles
                                                      .dataCell,
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {item.name}
                                                </td>
                                                <td
                                                  style={{
                                                    ...this.tableStyles
                                                      .dataCell,
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {item.stockStakeTypeName}
                                                </td>
                                                <td
                                                  style={{
                                                    ...this.tableStyles
                                                      .dataCell,
                                                    ...this.tableStyles
                                                      .amountCell,
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  ₹{+item.orderAmt.toFixed(2)}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                        </div> */}
                      </>
                    )}
                  </div>
                </div>
                {/* <hr style={{ borderTop: "2px solid #ccc", margin: "10px 0" }} /> */}

                <div
                  // className="container-fluid"
                  style={{
                    paddingLeft: 0,
                  }}
                >
                  {/* Cards 1 :  User Stats & Order Overview cards */}

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      // overflowX: "auto",
                      gap: "8px",
                      marginTop: "15px",
                    }}
                  >
                    {/* Bar Graph 1 : Date Wise Order AMT
                     */}
                    <div
                      style={{
                        width: "50%",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        borderRadius: 8,
                        padding: 10,
                        // maxHeight: "350px",
                        marginLeft: "2px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h2
                          style={{
                            fontSize: "15px",
                            fontWeight: "400",
                            color: "#1e293b",
                            padding: "2px 5px",
                            border: "1px solid #00b1ff",
                            borderRadius: "5px",
                            display: "inline-block",
                            letterSpacing: "0.6px",
                            backgroundColor: "#ffff",
                          }}
                        >
                          Product With Order AMT
                        </h2>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            flexDirection: "row",
                            width: "50%",
                          }}
                        >
                          <ToggleButtonGroup
                            color="primary"
                            value={prodWithOrderAmtAlignment}
                            exclusive
                            onChange={this.dateWiseOrderAmtHandleChange}
                            size="small"
                            aria-label="Small sizes"
                            sx={{
                              "& .MuiToggleButton-root": {
                                height: "35px",
                                fontSize: "0.75rem",
                              },
                            }}
                          >
                            <ToggleButton value="0">
                              <AssessmentIcon />
                            </ToggleButton>
                            <ToggleButton value="1">
                              <TableChartIcon />
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>
                      </div>
                      {prodWithOrderAmtAlignment == "0" ? (
                        <ReactApexChart
                          options={{
                            chart: {
                              type: "bar",
                              height: 300,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => {
                                  const dataId =
                                    productWithOrderAmtLocalStorage[
                                    config.dataPointIndex
                                    ];
                                  this.onclickProdWithOrderAmtData(dataId);
                                },
                              },
                            },
                            dataLabels: { enabled: false },
                            stroke: { curve: "smooth" },
                            xaxis: {
                              categories:
                                productWithOrderAmtLocalStorage?.length > 0
                                  ? productWithOrderAmtLocalStorage.map(
                                    (item) => item.date
                                  )
                                  : [],
                            },
                            tooltip: { theme: "light" },
                          }}
                          series={[
                            {
                              name: "Amount",
                              data:
                                productWithOrderAmtLocalStorage?.length > 0
                                  ? productWithOrderAmtLocalStorage.map(
                                    (item) => item.value
                                  )
                                  : [],
                            },
                          ]}
                          type="bar"
                          height={400}
                          width="100%"
                        />
                      ) : (
                        <div
                          style={{
                            // paddingTop: "1px",
                            maxHeight: "500px",
                            overflowY: "auto",
                          }}
                        >
                          <table style={this.tableStyles.table}>
                            <thead style={this.tableStyles.stickyHeader}>
                              <tr style={this.tableStyles.headerRow}>
                                <th
                                  style={{
                                    ...this.tableStyles.headerCell,
                                    textAlign: "center",
                                  }}
                                >
                                  Sr. no
                                </th>
                                <th
                                  style={{
                                    ...this.tableStyles.headerCell,
                                    textAlign: "center",
                                  }}
                                >
                                  Date
                                </th>
                                <th
                                  style={{
                                    ...this.tableStyles.headerCell,
                                    textAlign: "right",
                                  }}
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {productWithOrderAmtLocalStorage?.map(
                                (item, index, array) => (
                                  <tr
                                    key={item.id || index}
                                    style={{
                                      ...this.tableStyles.dataRow,
                                      ...(index % 2 === 0
                                        ? this.tableStyles.alternateRow
                                        : {}),
                                    }}
                                    onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      this.tableStyles.dataRowHover.backgroundColor)
                                    }
                                    onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      index % 2 === 0
                                        ? this.tableStyles.alternateRow
                                          .backgroundColor
                                        : this.tableStyles.dataRow
                                          .backgroundColor)
                                    }
                                  >
                                    <td
                                      style={{
                                        ...this.tableStyles.dataCell,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.index}
                                    </td>
                                    <td
                                      style={{
                                        ...this.tableStyles.dataCell,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.date}
                                    </td>
                                    <td
                                      style={{
                                        ...this.tableStyles.dataCell,
                                        ...this.tableStyles.amountCell,
                                        textAlign: "right",
                                      }}
                                    >
                                      ₹{+item?.value.toFixed(2)}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    {/* <div></div> */}

                    {/* Bar Graph  2 : Product With Order AMT
                     */}
                    <div
                      style={{
                        width: "50%",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        borderRadius: 8,
                        padding: 10,
                        // maxHeight: "350px",
                        marginLeft: "2px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {userCountsList.onclickProdWithOrderAmtData.length <=
                        0 ? (
                        <NoDataFound />
                      ) : (
                        <div style={this.accordionStyles.accordionContainer}>
                          {userCountsList.onclickProdWithOrderAmtData.map(
                            this.renderProductAccordionItem
                          )}
                        </div>
                        // <div style={this.accordionStyles.accordionContainer}>
                        //   {userCountsList &&
                        //     userCountsList != null &&
                        //     userCountsList.onclickProdWithOrderAmtData.map(
                        //       (item, index) => (
                        //         <div
                        //           style={this.accordionStyles.accordionItem}
                        //           key={index}
                        //         >
                        //           <div
                        //             style={{
                        //               ...this.accordionStyles.accordionHeader,
                        //               ...(this.state.hoveredIndex === index
                        //                 ? this.accordionStyles
                        //                     .accordionHeaderHover
                        //                 : {}),
                        //             }}
                        //             onClick={() =>
                        //               this.handleToggleForProd(index)
                        //             }
                        //             onMouseEnter={() =>
                        //               this.setState({ hoveredIndex: index })
                        //             }
                        //             onMouseLeave={() =>
                        //               this.setState({ hoveredIndex: null })
                        //             }
                        //           >
                        //             <span>
                        //               {item.name} -{" "}
                        //               <span
                        //                 style={{
                        //                   color: primary,
                        //                 }}
                        //               >
                        //                 ₹{+item.orderAmt.toFixed(2)}
                        //               </span>
                        //             </span>
                        //             {this.state.openIndexForProd === index ? (
                        //               <ExpandLessIcon />
                        //             ) : (
                        //               <ExpandMoreIcon />
                        //             )}
                        //           </div>
                        //           <div
                        //             style={{
                        //               ...this.accordionStyles.accordionContent,
                        //               ...(this.state.openIndexForProd === index
                        //                 ? this.accordionStyles
                        //                     .accordionContentOpen
                        //                 : {}),
                        //             }}
                        //           >
                        //             <div
                        //               style={{
                        //                 // paddingTop: "1px",
                        //                 maxHeight: "500px",
                        //                 overflowY: "auto",
                        //               }}
                        //             >
                        //               <table style={this.tableStyles.table}>
                        //                 <thead
                        //                   style={this.tableStyles.stickyHeader}
                        //                 >
                        //                   <tr
                        //                     style={this.tableStyles.headerRow}
                        //                   >
                        //                     <th
                        //                       style={{
                        //                         ...this.tableStyles.headerCell,
                        //                         textAlign: "center",
                        //                       }}
                        //                     >
                        //                       Sr. no
                        //                     </th>
                        //                     <th
                        //                       style={{
                        //                         ...this.tableStyles.headerCell,
                        //                         textAlign: "left",
                        //                       }}
                        //                     >
                        //                       Product Name
                        //                     </th>
                        //                     <th
                        //                       style={{
                        //                         ...this.tableStyles.headerCell,
                        //                         textAlign: "right",
                        //                       }}
                        //                     >
                        //                       Order Amount
                        //                     </th>
                        //                   </tr>
                        //                 </thead>
                        //                 <tbody>
                        //                   {item?.product?.map(
                        //                     (item, index, array) => (
                        //                       <tr
                        //                         key={item.id || index}
                        //                         style={{
                        //                           ...this.tableStyles.dataRow,
                        //                           ...(index % 2 === 0
                        //                             ? this.tableStyles
                        //                                 .alternateRow
                        //                             : {}),
                        //                         }}
                        //                         onMouseEnter={(e) =>
                        //                           (e.currentTarget.style.backgroundColor =
                        //                             this.tableStyles.dataRowHover.backgroundColor)
                        //                         }
                        //                         onMouseLeave={(e) =>
                        //                           (e.currentTarget.style.backgroundColor =
                        //                             index % 2 === 0
                        //                               ? this.tableStyles
                        //                                   .alternateRow
                        //                                   .backgroundColor
                        //                               : this.tableStyles.dataRow
                        //                                   .backgroundColor)
                        //                         }
                        //                       >
                        //                         <td
                        //                           style={{
                        //                             ...this.tableStyles
                        //                               .dataCell,
                        //                             textAlign: "center",
                        //                           }}
                        //                         >
                        //                           {index + 1}
                        //                         </td>
                        //                         <td
                        //                           style={{
                        //                             ...this.tableStyles
                        //                               .dataCell,
                        //                             textAlign: "left",
                        //                           }}
                        //                         >
                        //                           {item.name}
                        //                         </td>
                        //                         <td
                        //                           style={{
                        //                             ...this.tableStyles
                        //                               .dataCell,
                        //                             ...this.tableStyles
                        //                               .amountCell,
                        //                             textAlign: "right",
                        //                           }}
                        //                         >
                        //                           ₹{+item.orderAmt.toFixed(2)}
                        //                         </td>
                        //                       </tr>
                        //                     )
                        //                   )}
                        //                 </tbody>
                        //               </table>
                        //             </div>
                        //           </div>
                        //         </div>
                        //       )
                        //     )}
                        // </div>
                      )}
                    </div>
                  </div>

                  {/* Table1 : Top Performing Product List  */}
                  <div
                    style={{
                      width: "100%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: 10,
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                      marginTop: "15px",
                    }}
                  >
                    <div justifyContent="center">
                      <h2
                        style={{
                          fontSize: "15px",
                          fontWeight: "400",
                          color: "#1e293b",
                          padding: "2px 5px",
                          border: "1px solid #00b1ff",
                          borderRadius: "5px",
                          display: "inline-block",
                          letterSpacing: "0.6px",
                          backgroundColor: "#ffff",
                        }}
                      >
                        Top Performing Product List
                      </h2>
                    </div>
                    <div
                      style={{
                        paddingTop: "1px",
                        maxHeight: "700px",
                        overflowY: "auto",
                      }}
                    >
                      <table style={this.tableStyles.table}>
                        <thead style={this.tableStyles.stickyHeader}>
                          <tr style={this.tableStyles.headerRow}>
                            <th style={this.tableStyles.headerCell}>Sr. no</th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Product Name
                            </th>
                            <th style={this.tableStyles.headerCell}>
                              Product Code
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Group Name
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Category Name
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "right",
                              }}
                            >
                              Qty
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "right",
                              }}
                            >
                              Order Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {topPerformingProductLocalStorage?.topPerformingProductList?.map(
                            (item, index, array) => (
                              <tr
                                key={item.id || index}
                                style={{
                                  ...this.tableStyles.dataRow,
                                  ...(index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                    : {}),
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  this.tableStyles.dataRowHover.backgroundColor)
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                      .backgroundColor
                                    : this.tableStyles.dataRow
                                      .backgroundColor)
                                }
                              >
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {item.index}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.name}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {item.productCode}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.groupName}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.categoryName}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "right",
                                  }}
                                >
                                  {item.qty}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    ...this.tableStyles.amountCell,
                                    textAlign: "right",
                                  }}
                                >
                                  ₹{item.orderAmt}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* Table2 : Top Performing  Focus Product  List  */}
                  <div
                    style={{
                      width: "100%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: 10,
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                      marginTop: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#1e293b",
                        padding: "2px 5px",
                        border: "1px solid #00b1ff",
                        borderRadius: "5px",
                        display: "inline-block",
                        letterSpacing: "0.6px",
                        backgroundColor: "#ffff",
                      }}
                    >
                      Top Performing Focus Product List
                    </h2>
                    <div
                      style={{
                        paddingTop: "1px",
                        maxHeight: "700px",
                        overflowY: "auto",
                      }}
                    >
                      <table style={this.tableStyles.table}>
                        <thead style={this.tableStyles.stickyHeader}>
                          <tr style={this.tableStyles.headerRow}>
                            <th style={this.tableStyles.headerCell}>Sr. no</th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Product Name
                            </th>
                            <th style={this.tableStyles.headerCell}>
                              Product Code
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Group Name
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Category Name
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "right",
                              }}
                            >
                              Qty
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "right",
                              }}
                            >
                              Order Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {topPerformingProductLocalStorage?.topPerformingFocusProductList?.map(
                            (item, index, array) => (
                              <tr
                                key={item.id || index}
                                style={{
                                  ...this.tableStyles.dataRow,
                                  ...(index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                    : {}),
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  this.tableStyles.dataRowHover.backgroundColor)
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                      .backgroundColor
                                    : this.tableStyles.dataRow
                                      .backgroundColor)
                                }
                              >
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {item.index}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.name}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {item.productCode}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.groupName}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.categoryName}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "right",
                                  }}
                                >
                                  {item.qty}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    ...this.tableStyles.amountCell,
                                    textAlign: "right",
                                  }}
                                >
                                  ₹{item.orderAmt}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* Table3 : Top Performing Scheme List  */}
                  <div
                    style={{
                      width: "100%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: 10,
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                      marginTop: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#1e293b",
                        padding: "2px 5px",
                        border: "1px solid #00b1ff",
                        borderRadius: "5px",
                        display: "inline-block",
                        letterSpacing: "0.6px",
                        backgroundColor: "#ffff",
                      }}
                    >
                      Top Performing Scheme List
                    </h2>
                    <div
                      style={{
                        paddingTop: "1px",
                        maxHeight: "700px",
                        overflowY: "auto",
                      }}
                    >
                      <table style={this.tableStyles.table}>
                        <thead style={this.tableStyles.stickyHeader}>
                          <tr style={this.tableStyles.headerRow}>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "center",
                              }}
                            >
                              Sr. no
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              {" "}
                              Name
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "left",
                              }}
                            >
                              Description
                            </th>
                            <th
                              style={{
                                ...this.tableStyles.headerCell,
                                textAlign: "right",
                              }}
                            >
                              Offer Count
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {topPerformingProductLocalStorage?.topPerformingSchemeList?.map(
                            (item, index, array) => (
                              <tr
                                key={item.id || index}
                                style={{
                                  ...this.tableStyles.dataRow,
                                  ...(index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                    : {}),
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  this.tableStyles.dataRowHover.backgroundColor)
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  index % 2 === 0
                                    ? this.tableStyles.alternateRow
                                      .backgroundColor
                                    : this.tableStyles.dataRow
                                      .backgroundColor)
                                }
                              >
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {item.index}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.name}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "left",
                                  }}
                                >
                                  {item.discription}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    ...this.tableStyles.amountCell,
                                    textAlign: "right",
                                  }}
                                >
                                  {item.offerCount}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      borderRadius: 8,
                      padding: 10,
                      // maxHeight: "350px",
                      marginLeft: "2px",
                      backgroundColor: "#fff",
                      marginTop: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#1e293b",
                        padding: "2px 5px",
                        border: "1px solid #00b1ff",
                        borderRadius: "5px",
                        display: "inline-block",
                        letterSpacing: "0.6px",
                        backgroundColor: "#ffff",
                      }}
                    >
                      Month Wise Sales
                    </h2>
                    <ReactApexChart
                      options={{
                        chart: { type: "bar", height: 400 },
                        dataLabels: { enabled: false },
                        stroke: { curve: "smooth" },
                        xaxis: {
                          categories:
                            userCountsList?.monthWiseData?.length > 0
                              ? userCountsList?.monthWiseData.map(
                                (item) => item.month
                              )
                              : [],
                        },
                        tooltip: { theme: "light" },
                      }}
                      series={[
                        {
                          name: "Amount",
                          data:
                            userCountsList?.monthWiseData?.length > 0
                              ? userCountsList?.monthWiseData?.map(
                                (item) => item.value
                              )
                              : [],
                        },
                      ]}
                      type="bar"
                      height={300}
                      width="100%"
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  ...this.styles.sectionForSalesTeam,
                  height:
                    dashboardData?.newSalesInfo.length != 0 ? "564px" : "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      width: "50%",
                    }}
                  >
                    <h2
                      style={{ ...this.tableStyles.sectionTitle, width: "20%" }}
                    >
                      Sales Team List
                    </h2>
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search by Sales Team Name..."
                        value={this.searchValueForSalesTeamList}
                        onChange={(e) =>
                          this.setState({
                            searchValueForSalesTeamList: e.target.value,
                          })
                        }
                        style={this.tableStyles.searchInput}
                        onFocus={(e) =>
                          Object.assign(
                            e.target.style,
                            this.tableStyles.searchInputFocus
                          )
                        }
                        onBlur={(e) =>
                          Object.assign(e.target.style, {
                            borderColor: "#E5F1F9",
                            boxShadow: "none",
                          })
                        }
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection: "row",
                      width: "50%",
                    }}
                  >
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                        gap: "8px",
                        maxWidth: "600px",
                      }}
                    >
                      <div
                        style={{
                          ...this.tableStyles.searchContainer,
                          flexDirection: "column",
                          marginBottom: 0,
                        }}
                      >
                        <input
                          type="date"
                          value={dayjs(this.state.fromDate).format(
                            "YYYY-MM-DD"
                          )}
                          onChange={this.changeDate("fromDate")}
                          style={this.tableStyles.searchInput}
                          onFocus={(e) =>
                            Object.assign(
                              e.target.style,
                              this.tableStyles.searchInputFocus
                            )
                          }
                          onBlur={(e) =>
                            Object.assign(e.target.style, {
                              borderColor: "#E5F1F9",
                              boxShadow: "none",
                            })
                          }
                          defaultValue={dayjs().format("YYYY-MM-DD")}
                          max={dayjs().format("YYYY-MM-DD")}
                        />
                      </div>
                      {/* 
                      <div
                        style={{
                          ...this.tableStyles.searchContainer,
                          flexDirection: "column",
                          marginBottom: 0,
                        }}
                      >
                        <input
                          type="date"
                          value={this.fromDate}
                          onChange={this.changeDate("fromDate")}
                          style={this.tableStyles.searchInput}
                          onFocus={(e) =>
                            Object.assign(
                              e.target.style,
                              this.tableStyles.searchInputFocus
                            )
                          }
                          onBlur={(e) =>
                            Object.assign(e.target.style, {
                              borderColor: "#E5F1F9",
                              boxShadow: "none",
                            })
                          }
                          defaultValue={dayjs().format("YYYY-MM-DD")}
                          max={dayjs().format("YYYY-MM-DD")}
                        />
                      </div> */}
                      <button
                        style={{
                          padding: "7px 16px",
                          borderRadius: "6px",
                          border: "none",
                          background: "#2563eb",
                          color: "#fff",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        onClick={this.searchSalesTeamData}
                      >
                        Search
                      </button>
                      <button
                        style={{
                          padding: "7px 16px",
                          borderRadius: "6px",
                          border: "none",
                          background: "#22c55e",
                          color: "#fff",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        onClick={this.generateExcel}
                      >
                        Excel
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflow: "auto",
                  }}
                >
                  <div style={this.tableStyles.tabContainer}>
                    <div
                      style={{
                        ...this.tableStyles.tab,
                        ...(this.state.activeTab === "0"
                          ? this.tableStyles.activeTab
                          : {}),
                      }}
                      onClick={() => this.setState({ activeTab: "0" })}
                    >
                      {"All" +
                        " ( " +
                        dashboardData?.newSalesInfo.length +
                        " ) "}
                    </div>
                    <div
                      style={{
                        ...this.tableStyles.tab,
                        ...(this.state.activeTab === "1"
                          ? this.tableStyles.activeTab
                          : {}),
                      }}
                      onClick={() => this.setState({ activeTab: "1" })}
                    >
                      {"Present" +
                        " ( " +
                        dashboardData?.newSalesInfo.filter(
                          (row) => row.attendenceStatus == 1
                        ).length +
                        " ) "}
                    </div>
                    <div
                      style={{
                        ...this.tableStyles.tab,
                        ...(this.state.activeTab === "2"
                          ? this.tableStyles.activeTab
                          : {}),
                      }}
                      onClick={() => this.setState({ activeTab: "2" })}
                    >
                      {"Absent" +
                        " ( " +
                        dashboardData?.newSalesInfo.filter(
                          (row) => row.attendenceStatus == 0
                        ).length +
                        " ) "}
                    </div>
                    <div
                      style={{
                        ...this.tableStyles.tab,
                        ...(this.state.activeTab === "3"
                          ? this.tableStyles.activeTab
                          : {}),
                      }}
                      onClick={() => this.setState({ activeTab: "3" })}
                    >
                      {"Late" +
                        " ( " +
                        dashboardData?.newSalesInfo.filter(
                          (row) => row.checkInStatus == 1
                        ).length +
                        " ) "}
                    </div>
                    <div
                      style={{
                        ...this.tableStyles.tab,
                        ...(this.state.activeTab === "4"
                          ? this.tableStyles.activeTab
                          : {}),
                      }}
                      onClick={() => this.setState({ activeTab: "4" })}
                    >
                      {"On leave" +
                        " ( " +
                        dashboardData?.newSalesInfo.filter(
                          (row) => row.attendenceStatus == 2
                        ).length +
                        " ) "}
                    </div>
                  </div>
                  <div style={this.tableStyles.tableWrapper}>
                    <table style={this.tableStyles.table}>
                      <thead style={this.tableStyles.stickyHeader}>
                        <tr style={this.tableStyles.headerRow}>
                          <th style={this.tableStyles.headerCell}>Sr.No</th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "left",
                            }}
                          >
                            Sales Team Name
                          </th>
                          {localStorage.getItem(
                            "isShowSalesTeamTypeAtAnalyticalAdminDash"
                          ) &&
                            localStorage.getItem(
                              "isShowSalesTeamTypeAtAnalyticalAdminDash"
                            ) == 1 && (
                              <th
                                style={{
                                  ...this.tableStyles.headerCell,
                                  textAlign: "left",
                                }}
                              >
                                Type
                              </th>
                            )}

                          {localStorage.getItem(
                            "showAreaDistrictColumnsOnSalesTeamListDashboard"
                          ) &&
                            localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 && (
                              <>
                                <th
                                  style={{
                                    ...this.tableStyles.headerCell,
                                    textAlign: "left",
                                    width: "15%",
                                  }}
                                >
                                  District
                                </th>

                                <th
                                  style={{
                                    ...this.tableStyles.headerCell,
                                    textAlign: "left",
                                    width: "15%",
                                  }}
                                >
                                  Area
                                </th>
                              </>
                            )}
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Beat Count
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Total Outlet
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Productive Call
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Unvisited Outlet
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Zero Order
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Total Order Amount
                          </th>
                          <th
                            style={{
                              ...this.tableStyles.headerCell,
                              textAlign: "right",
                            }}
                          >
                            Total Sales Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.newSalesInfo.length != 0 &&
                          this.getFilteredTableDataForSalesTeamList(
                            activeTab == "0"
                              ? dashboardData?.newSalesInfo
                              : activeTab == "1"
                                ? dashboardData?.newSalesInfo.filter(
                                  (row) => row.attendenceStatus == 1
                                )
                                : activeTab == "2"
                                  ? dashboardData?.newSalesInfo.filter(
                                    (row) => row.attendenceStatus == 0
                                  )
                                  : activeTab == "4"
                                    ? dashboardData?.newSalesInfo.filter(
                                      (row) => row.attendenceStatus == 2
                                    )
                                    : dashboardData?.newSalesInfo.filter(
                                      (row) => row.checkInStatus == 1
                                    )
                          )?.map((row, index) => (
                            <tr
                              key={index + 1}
                              style={{
                                ...this.tableStyles.dataRow,
                                ...(index % 2 === 0
                                  ? this.tableStyles.alternateRow
                                  : {}),
                              }}
                              onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                this.tableStyles.dataRowHover.backgroundColor)
                              }
                              onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                index % 2 === 0
                                  ? this.tableStyles.alternateRow
                                    .backgroundColor
                                  : this.tableStyles.dataRow.backgroundColor)
                              }
                            >
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "center",
                                }}
                                width={"5%"}
                              >
                                {index + 1}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: cyanBlue,
                                }}
                                width={"13%"}
                              >
                                <Link
                                  color={cyanBlue}
                                  component={RouterLink}
                                  to={
                                    "/gmap-with-functionality/" +
                                    row.salesTeamId +
                                    "/" +
                                    row.userTypeId
                                  }
                                >
                                  {row.name}
                                </Link>
                              </td>
                              {localStorage.getItem(
                                "isShowSalesTeamTypeAtAnalyticalAdminDash"
                              ) &&
                                localStorage.getItem(
                                  "isShowSalesTeamTypeAtAnalyticalAdminDash"
                                ) == 1 && (
                                  <td
                                    style={{
                                      ...this.tableStyles.dataCell,
                                      textAlign: "left",
                                    }}
                                    width={"12%"}
                                  >
                                    {row.stockStakeHolderTypeName}
                                  </td>
                                )}
                              {localStorage.getItem(
                                "showAreaDistrictColumnsOnSalesTeamListDashboard"
                              ) &&
                                localStorage.getItem(
                                  "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                ) == 1 && (
                                  <>
                                    <td
                                      style={{
                                        ...this.tableStyles.dataCell,
                                        textAlign: "left",
                                        width: "5%",
                                      }}
                                      width={"5%"}
                                    >
                                      {row.district_names}
                                    </td>

                                    <td
                                      style={{
                                        ...this.tableStyles.dataCell,
                                        textAlign: "left",
                                        width: "5%",
                                      }}
                                      width={"5%"}
                                    >
                                      {row.area_names}
                                    </td>
                                  </>
                                )}
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                  position: "relative",
                                  cursor: "pointer",
                                  ...this.tableStyles.amountCell,
                                }}
                                onMouseEnter={(e) => {
                                  clearTimeout(this.tooltipTimeout);
                                  this.showTooltip(
                                    e,
                                    row.beats != 0
                                      ? row.beats
                                      : "Beat not found"
                                  );
                                }}
                                width={"10%"}
                                onMouseLeave={this.hideTooltipWithDelay}
                              >
                                {row.beatCount}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                {row.totalOutletCount}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                {row.productiveCall}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                {row.unvisitedOutletCount}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                {row.zeroOrderCount}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  ...this.tableStyles.amountCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                ₹{row.totalAmount.toLocaleString()}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  ...this.tableStyles.amountCell,
                                  textAlign: "right",
                                }}
                                width={"10%"}
                              >
                                ₹{row.totalSalesAmt.toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        {dashboardData.newSalesInfo.length != 0 &&
                          this.getFilteredTableDataForSalesTeamList(
                            activeTab == "0"
                              ? dashboardData?.newSalesInfo
                              : activeTab == "1"
                                ? dashboardData?.newSalesInfo.filter(
                                  (row) => row.attendenceStatus == 1
                                )
                                : activeTab == "2"
                                  ? dashboardData?.newSalesInfo.filter(
                                    (row) => row.attendenceStatus == 0
                                  )
                                  : activeTab == "4"
                                    ? dashboardData?.newSalesInfo.filter(
                                      (row) => row.attendenceStatus == 2
                                    )
                                    : dashboardData?.newSalesInfo.filter(
                                      (row) => row.checkInStatus == 1
                                    )
                          )?.length > 0 && (
                            <tr
                              style={{
                                background: "#f3f4f6",
                                fontWeight: "bold",
                              }}
                            >
                              <td style={this.tableStyles.dataCell}></td>
                              <td style={this.tableStyles.dataCell}></td>
                              <td style={this.tableStyles.dataCell}></td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                              >
                                Total
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                              >
                                {totalOutletCount}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                              >
                                {productiveCall}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                              >
                                {unvisited}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  textAlign: "right",
                                }}
                              >
                                {zero}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  ...this.tableStyles.amountCell,
                                  textAlign: "right",
                                }}
                              >
                                ₹{(+totalAmount).toLocaleString()}
                              </td>
                              <td
                                style={{
                                  ...this.tableStyles.dataCell,
                                  ...this.tableStyles.amountCell,
                                  textAlign: "right",
                                }}
                              >
                                ₹{(+salesAmt).toLocaleString()}
                              </td>
                            </tr>
                          )}
                        {dashboardData.newSalesInfo.length != 0 &&
                          this.getFilteredTableDataForSalesTeamList(
                            activeTab == "0"
                              ? dashboardData?.newSalesInfo
                              : activeTab == "1"
                                ? dashboardData?.newSalesInfo.filter(
                                  (row) => row.attendenceStatus == 1
                                )
                                : activeTab == "2"
                                  ? dashboardData?.newSalesInfo.filter(
                                    (row) => row.attendenceStatus == 0
                                  )
                                  : activeTab == "4"
                                    ? dashboardData?.newSalesInfo.filter(
                                      (row) => row.attendenceStatus == 2
                                    )
                                    : dashboardData?.newSalesInfo.filter(
                                      (row) => row.checkInStatus == 1
                                    )
                          )?.length === 0 && (
                            <tr>
                              <td colSpan="10" style={this.tableStyles.noData}>
                                No matching teams found.
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {this.state.tooltip.visible && (
                <div
                  style={{
                    position: "absolute",
                    left: this.state.tooltip.x,
                    top: this.state.tooltip.y,
                    background: "#333333",
                    color: "#fff",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    fontSize: "13px",
                    pointerEvents: "auto",
                    zIndex: 9999,
                    transform: "translate(-50%, -100%)",
                    width: "220px",
                    maxHeight: "150px",
                    overflow: "auto",
                    whiteSpace: "pre-line",
                  }}
                  onMouseEnter={() => clearTimeout(this.tooltipTimeout)}
                  onMouseLeave={this.hideTooltipWithDelay}
                >
                  {this.state.tooltip.text}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userCountsList: state.region,
  companyCategoryList: state.companyCateoryConfiguration,
  dashboardData: state.adminDashboard,
  beatList: state.beat,
});

const mapDispatchToProps = {
  getUserCountsAndOrderAmt,
  getUsersCheckedInSummary,
  getProductWithOrderAmt,
  getRegionNew,
  getTopPerformingProductsAndScheme,
  getMonthTillDateWiseSales,
  getSalesTeamInfoByDatesWithAttendance,
  getSalesTeamInfoByDatesAndFlag,
  getBeatFromSalesTeamId,
  showLoador,
  showNotification,
  getActiveUsers,
  getActiveDealers,
  getNewAddedOutlets,
  getActiveTeamMembers,
  getOnclickDateWiseOrderAmtData,
  getOnclickProdWithOrderAmtData,
  getNewSalesTeamInfoByDateForAdmin,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NewAnalyticalAdminDashboard);
